import {
    RequestDataResponse,
} from "@/types/service-response";


export default class RequestData {
  private constructor(
    readonly alreadyHaveAccount: boolean,
    readonly boarderGroup: string,
    readonly customer: string,
    readonly email: string,
    readonly familyName:string,
    readonly firstName: string,
    readonly phoneNumber: string,
  ) {}


  static createFromResponse(responseData: RequestDataResponse): RequestData {

    return new RequestData(
      responseData.alreadyHaveAccount,
      responseData.boarderGroup,
      responseData.customer,
      responseData.email,
      responseData.familyName,
      responseData.firstName,
      responseData.phoneNumber,
    )
  }


}